export const validationType = {
  INPUT_FIELD: 'INPUT_FIELD',
  MULTI_FIELD: 'MULTI_FIELD'
}
